import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CalendarComponentOptions } from 'ion2-calendar';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.page.html',
  styleUrls: ['./calendar.page.scss'],
})
export class CalendarPage implements OnInit {

  @Input() defaultDate: string;
  @HostBinding('style.--calender-primary-color')
  public calenderPrimaryColor: string = '#ffbc00';

  @HostBinding('style.--calender-text-color')
  public calenderTextColor: string = '#ffffff';

  public option: CalendarComponentOptions = {
    color: 'gastro-calendar'
  };

  public date: string;
  public type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  public minDate: Date;

  constructor(public modalController: ModalController, public appService: AppServiceService, public translate: TranslateService, public router: Router) {

  }

  ngOnInit() {
    this.date = this.defaultDate;
  }

  ngDoCheck(){
    if (this.appService.appObject.theme && this.appService.appObject.theme.app && this.appService.appObject.theme.app.primaryColor)
    this.calenderPrimaryColor = this.appService.appObject.theme.app.primaryColor;
    if (this.appService.appObject.theme && this.appService.appObject.theme.app && this.appService.appObject.theme.app.primaryColor)
    this.calenderTextColor = this.appService.appObject.theme.app.primaryTextColor;
  }

  onChange($event) {
    // console.log("Mona Huththakda meka :",$event);
  }

  public dismiss(day) {
    this.modalController.dismiss({
      'dismissed': true,
      'selectedDate': !day ? null : day
    });
  }

  async  selectDate(){
    let day = this.date ? await this.formatDate(this.date) : null;
    this.dismiss(day);
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');
  }

}
